export default __webpack_public_path__ + "static/media/AlexForestResume.52717444.pdf";